import { render, staticRenderFns } from "./SingleCard.vue?vue&type=template&id=5b7cf0f6&scoped=true&"
import script from "./SingleCard.vue?vue&type=script&lang=js&"
export * from "./SingleCard.vue?vue&type=script&lang=js&"
import style0 from "./SingleCard.vue?vue&type=style&index=0&id=5b7cf0f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7cf0f6",
  null
  
)

export default component.exports